import React from "react";
import { ChartNew } from "../../../../../components";

const TableChartList = () => {
  const rawData = [
    {
      clientName: "IBM",
      "1-30": 360,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Sep, 2025",
    },
    {
      clientName: "tCS",
      "1-30": 230,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "08 sep, 2025",
    },
    {
      clientName: "INFOSYS",
      "1-30": 190,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Jul, 2025",
    },
    {
      clientName: "TEK",
      "1-30": 410,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Jul, 2025",
    },
    {
      clientName: "IBM",
      "1-30": 110,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Jul, 2025",
    },
    {
      clientName: "IBM",
      "1-30": 70,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Jul, 2025",
    },
    {
      clientName: "IBM",
      "1-30": 210,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Jul, 2025",
    },
    {
      clientName: "IBM",
      "1-30": 150,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Jul, 2025",
    },
    {
      clientName: "IBM",
      "1-30": 320,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Jul, 2025",
    },
    {
      clientName: "IBM",
      "1-30": 210,
      "30-60": 0,
      "60-90": 560,
      paymentDate: "03 Jul, 2025",
    },
  ];

  return (
    <div className="mt-3 h-[500px]">
      <ChartNew
        type="tablechart"
        rawData={rawData}
        chartLabel={"clientName"}
        chartValue={"1-30"}
        chartToolbarRight={{
          date: true,
          filter: true,
          screenShare: true,
          compare: true,
          expand: true,
        }}
        // onDateChange={(val) => console.log(val)}
        dateFilterKey={"paymentDate"}
      />
    </div>
  );
};

export default TableChartList;
